export const UPDATE_FILTER = 'UPDATE_FILTER';

export function updateFilter(filter) {
  return {
    type: UPDATE_FILTER,
    payload: filter,
  };
}
